export default __webpack_public_path__ + "locales/pt/CreateEditRoomDialog.json?hash=33ef7de6705c8ea8ddf28f3fbdb68344";